module.exports = __webpack_public_path__ + "static/img/2.c4786f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/2.png
// module id = lk8U
// module chunks = 0